import React, { Component } from "react";
import axios from "axios";
import * as _ from "lodash-joins";
import styled from "styled-components";
import Collapse from "@material-ui/core/Collapse";
import Modal from "react-bootstrap/Modal";
import Loader from "react-loader-spinner";
import DateRange from "../../../../commons/components/DateRange";
import SelectBox from "../../../../commons/components/SelectBox";
import Pagination from "../../../../commons/components/Paginations";
import CS from "../../../../commons/services/Common";
import MS from "../../../../commons/services/Moment";
import AS from "../../../Login/Service/Authentication";
import PS from "../../../PlantList/MonitoringApiService";
import Graph from "./Graph";

//import 'echart-theme.js';
import ReactECharts from "echarts-for-react";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { ROUTES } from "../../../../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";

/**
 * 전체 발전소 목록 컴포넌트
 */
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plantId: props.match.params.plantId,
      isLoading: true,
      sInverterSerialNos: [],
      inverterSerialNos: [],
      isModalOpen: false,
      fromDate: MS.addAndFormat(new Date(), -3, "hour", "YYYY-MM-DD HH:00:00"),
      toDate: MS.format(new Date(), "YYYY-MM-DD HH:mm:ss"),
      items: [],
      chartData: [],
      item: {},
      totalCount: 0,
      isListView: false,
      testData: {},
      testOptions: {},
      timeOptions: [],
      timeRangeNum: 3,
    };
  }

  componentDidMount() {
    this.buildTimeOptions();
    this.getPlantInfo();
  }

  buildTimeOptions = () => {
    const { fromDate, timeRangeNum } = this.state;
    const options = [];
    const start = 6;
    let end = 22;
    if (MS.isToday(fromDate.substring(0, 10))) {
      end = parseInt(MS.format(new Date(), "H")) + 1;
    }

    for (let i = 0; i < end - start; i++) {
      const start = i + 6;
      const end = start + timeRangeNum;
      const text = `${CS.fillZero(2, start.toString())}:00`;
      options.push({
        text: `${text} ~ ${CS.fillZero(2, end.toString())}:00`,
        value: text + ":00",
      });
    }
    this.setState({
      timeOptions: options,
    });
  };

  async getPlantInfo() {
    const { plantId, inverterSerialNos } = this.state;
    if (inverterSerialNos.length == 0) {
      const res = await axios.get(
        `/usr/api/user-plant/info?plantIds=${plantId}`
      );
      this.setState({
        info: res.data[0],
      });
      const plantInfos = AS.getLoggedInPlantInfos();
      let filteredPlantInfo = plantInfos.filter((v) => v.id == plantId);
      let inverterSerialNos = CS.getKeyValues(
        filteredPlantInfo[0].invs,
        "serialNo"
      );
      this.setState({
        inverterSerialNos: inverterSerialNos,
        sInverterSerialNos: inverterSerialNos,
      });
      this.getData(inverterSerialNos);
    } else {
      this.getData(inverterSerialNos);
    }
  }

  getData = async (sSerialNos) => {
    let copySerialNos = CS.cloneObj(sSerialNos);
    if (copySerialNos.length > 1) {
      copySerialNos = copySerialNos.splice(0, 1);
    }
    await this.setState({
      items: [],
      isLoading: true,
    });
    const { fromDate, toDate } = this.state;
    const inverters1 = await this.getInverterList(
      copySerialNos,
      fromDate,
      toDate,
      "inverter"
    );
    this.setState({
      items: inverters1,
      //isLoading: inverters1.length > 0 ? true : false
    });
    const inverters2 = await this.getInverterList(
      copySerialNos,
      fromDate,
      toDate,
      "inverter_history"
    );
    inverters1.push(...inverters2);
    /*
        this.setState({
            items: inverters1,
            totalCount: inverters1.length,
            isLoading: false
        });
        console.log(inverters1);
        */

    /*
        const group = _.chain(inverters1)
            .groupBy(v => `${v.serialNo} ${v.time.substring(0, 16)}`)
            .map((list, grouping) => ({ grouping, list }))
            .value();
        */

    const group2 = _.chain(inverters1)
      .groupBy((v) => `${v.serialNo} ${v.time.substring(0, 16)}`)
      .map((list) => {
        return list[0];
      })
      .value();

    /*
        const items = [];
        group.some(v => {
            items.push(v.list[0]);
        });
        */
    this.setState({
      items: group2,
      totalCount: group2.length,
      isLoading: false,
    });
    //console.log(items);
  };

  getInverterList = async (
    inverterSerialNos,
    fromDate,
    toDate,
    collectionName
  ) => {
    const inverters = await PS.getInverterList({
      collectionName: collectionName,
      inverterSerialNos: inverterSerialNos,
      fromDate: fromDate,
      toDate: toDate,
    });
    //console.log(inverters)
    //inverters.map(v => v.type = collectionName);
    return inverters;
  };

  handleDateChange = async (ranges) => {
    await this.setState({
      fromDate: `${ranges[0]} 00:00:00`,
      toDate: `${ranges[1]} 23:59:59`,
    });
    this.buildTimeOptions();
    this.getData(this.state.sInverterSerialNos);
  };

  handleTimeChange = async (time) => {
    const { fromDate, toDate, timeRangeNum } = this.state;
    const startHourArr = time.split(":");
    const endHour = CS.fillZero(
      2,
      (parseInt(startHourArr[0]) + timeRangeNum - 1).toString()
    );
    await this.setState({
      fromDate: `${fromDate.substring(0, 10)} ${time}`,
      toDate: `${toDate.substring(0, 10)} ${endHour}:59:59`,
    });
    this.getData(this.state.sInverterSerialNos);
  };

  handleInverterChange = async () => {
    let serialNo = document.getElementById("serialNo").value;
    let sSerialNos;
    if (serialNo) {
      sSerialNos = new Array(serialNo);
    } else {
      sSerialNos = this.state.inverterSerialNos;
    }
    this.setState({
      sInverterSerialNos: sSerialNos,
    });
    this.getData(sSerialNos);
  };

  handleDetail = (row) => {
    this.setState({
      isModalOpen: true,
      item: row,
    });
  };

  render() {
    const {
      isLoading,
      items,
      item,
      totalCount,
      inverterSerialNos,
      isModalOpen,
      plantId
    } = this.state;

    const projectId = this.props.match.params.projectId;
    const { t } = this.props;
    return (
      <>
        <div className="page-tit gray">
          <div className="container f-stack">
            <h2 className="tit">{t('key382')}</h2>
            <a
              onClick={() =>
                window.open(
                  ROUTES.PLANT_STATUS(projectId).INVERTER_STAT(plantId)
                )
              }
              target="_blank"
              className="btn primary w300"
            >
              {t('key383')}
            </a>
          </div>
        </div>
        <div className="container">
          <div className="top-search">
            <div className="txt">
              <strong>{t('key384')}</strong> {t('key385')} {totalCount}{t('key386')}
            </div>
            <div className="search">
              <form onSubmit={(e) => e.preventDefault()}>
                <DateRange handleDateChange={this.handleDateChange} />
                &nbsp;
                <SelectBox
                  name="moduleCompanyId"
                  id="moduleCompanyId"
                  value={""}
                  default={t('key388')}
                  items={this.state.timeOptions}
                  handleSelectChange={this.handleTimeChange}
                />
                {inverterSerialNos.length > 1 && (
                  <select
                    id="serialNo"
                    title="정렬선택"
                    onChange={this.handleInverterChange}
                  >
                    {inverterSerialNos.map((row, index) => (
                      <option key={index} value={row}>{`인버터${
                        index + 1
                      }`}</option>
                    ))}
                  </select>
                )}
              </form>
            </div>
          </div>
          <Graph data={items} />
          {/*
                    <ReactECharts
                        option={{
                            xAxis: {
                                type: 'category',
                                data: CS.getKeyValues(items.reverse(), 'time')
                            },
                            yAxis: {
                                type: 'value'
                            },
                            series: [
                                {
                                data: CS.getKeyValues(items.reverse(), 'power'),
                                type: 'line'
                                }
                            ]
                        }}
                        theme="myTheme" // 적용할 테마 이름
                        opts={{ renderer: 'svg', width: 'auto', height: 'auto' }}
                    />
                    */}
          <ButtonContainer>
            <button
              onClick={() =>
                this.setState({ isListView: !this.state.isListView })
              }
            >
              {t('key394')}
            </button>
          </ButtonContainer>
          <Collapse in={this.state.isListView}>
            <div className="table-wrapper mt-30">
              <table className="h-table">
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "13%" }} />
                  <col />
                  <col style={{ width: "8%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "9%" }} />
                  <col style={{ width: "9%" }} />
                  <col style={{ width: "9%" }} />
                  <col style={{ width: "7%" }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>{t('key711')}</th>
                    <th>{t('key712')}</th>
                    <th>{t('key713')}</th>
                    <th>{t('key714')}</th>
                    <th>{t('key715')}</th>
                    <th>{t('key716')}</th>
                    <th>{t('key717')}</th>
                    <th>{t('key718')}</th>
                    <th>{t('key719')}</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="9">
                        <Loader
                          type="ThreeDots"
                          color="#211b41"
                          height="25"
                          width="25"
                        />
                      </td>
                    </tr>
                  ) : items.length > 0 ? (
                    items.map((row, index) => (
                      <tr key={row.id}>
                        <td>
                          <label className="num">{index + 1}</label>
                        </td>
                        <td>{row.time.substring(0, 16)}</td>
                        <td>{row.serialNo}</td>
                        <td>{row.power}</td>
                        <td>{CS.setComma(row.accumulationPower)}</td>
                        <td>{row.pvCurrent}</td>
                        <td>{row.pvVolt}</td>
                        <td>
                          {PS.formatNumber((row.pvCurrent * row.pvVolt) / 1000)}
                        </td>
                        <td>
                          <a
                            onClick={() => this.handleDetail(row)}
                            className="btn sm mr-5"
                          >
                            {t('key720')}
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">{t('key721')}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {
              <div className="paging-wrap">
                <Pagination
                  handlePagingChange={this.getItems}
                  count={this.state.pageSize}
                />
              </div>
            }
          </Collapse>
        </div>

        <DetailModal
          show={isModalOpen}
          item={item}
          closeModal={() => this.setState({ isModalOpen: false })}
          t={t}
        />
      </>
    );
  }
}

class DetailModal extends React.Component {
  render() {
    const { show, item, closeModal, t } = this.props;
    return (
      <>
        <Modal show={show} size="lg" centered>
          <Modal.Body>
            <div className="modal-header">
              <button type="button" className="close" onClick={closeModal}>
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title">{t('key722')}</h4>
            </div>
            <div className="modal-body">
              {!CS.checkIsEmptyObject(item) && (
                <div className="p-body">
                  <table className="v-table">
                    <colgroup>
                      <col style={{ width: "15%" }} />
                      <col />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "18%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "18%" }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>{t('key723')}</th>
                        <td>
                          <b>{item.time}</b>
                        </td>
                        <th>{t('key724')}</th>
                        <td>{item.power}</td>
                        <th>{t('key725')}</th>
                        <td>{CS.setComma(item.accumulationPower)}</td>
                      </tr>
                      <tr>
                        <th>{t('key726')}</th>
                        <td>{item.pvVolt}</td>
                        <th>{t('key727')}</th>
                        <td>{item.pvCurrent}</td>
                        <th>{t('key728')}</th>
                        <td>
                          {PS.formatNumber(
                            (item.pvCurrent * item.pvVolt) / 1000
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th>{t('key729')}</th>
                        <td>{item.lineRVolt}</td>
                        <th>{t('key730')}</th>
                        <td>{item.lineSVolt}</td>
                        <th>{t('key731')}</th>
                        <td>{item.lineTVolt}</td>
                      </tr>
                      <tr>
                        <th>{t('key732')}</th>
                        <td>{item.lineRCurrent}</td>
                        <th>{t('key733')}</th>
                        <td>{item.lineSCurrent}</td>
                        <th>{t('key734')}</th>
                        <td>{item.lineTCurrent}</td>
                      </tr>
                      <tr>
                        <th>{t('key735')}</th>
                        <td>{item.temperature}</td>
                        <th>{t('key736')}</th>
                        <td>{item.hertz}</td>
                        <th>{t('key737')}</th>
                        <td>{item.runStatus}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="modal-footer2">
              <button
                type="button"
                className="btn blue"
                onClick={() => this.controlIdChangeModal(show)}
              >
                {t('key738')}
              </button>
              <button type="button" className="btn red" onClick={closeModal}>
                {t('key739')}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
const ButtonContainer = styled.div`
  text-align: right;
  button {
    width: 120px;
    padding: 10px 0;
    border-radius: 5px;
    color: var(--grey-900);
    font-weight: 600;
    background-color: var(--primary-500);
    border: 1px solid var(--primary-500);
  }
`;
export default withTranslation()(Index);
